<template>
  <div id=navbar>
      <nav class="navlogo">
        <a href="" >
          <img src="../assets/logotipo.png" class="logotipo" width="85" height="35" alt="Logotipo Bo'ol">
        </a>
      </nav>
      <nav class="navbar">
        <v-app-bar-nav-icon @click="drawer =!drawer" class="logotipo sidebar" color="#fefeff"></v-app-bar-nav-icon>
        <span class="centradoLabels">{{step}}</span>
      </nav>
      <!--
      <v-app-bar absolute flat short dense color="#717171" class="sidebar">
        <v-app-bar-nav-icon @click="drawer =!drawer" color="purple--text"></v-app-bar-nav-icon>
        <v-spacer></v-spacer>
        <v-toolbar-title class="white--text">{{step}}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-app-bar>-->
    
      <v-navigation-drawer v-model="drawer" temporary absolute="">
        <v-list>
          <v-list-item-group>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title @click="drawer = !drawer">Usuario administrador</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Empresa comercial</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Catálogos de Áreas</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Alta Estructura Organizacional</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Calendarios</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>
  </div>
</template>
<script>
  export default {
    name: 'NavbarLogotipo',
    data(){
      return{
        step:localStorage.step,
        drawer:false,
        
      }
    }
  }
</script>
